import { Link } from "react-router-dom";
import { CreditCard } from "lucide-react";
import { useApi } from "@/hooks/useApi";
import { Button } from "@/components/ui/button";

export function PlanBadge() {
  const { data } = useApi("/billing/me");
  if (!data) return null;
  const warn = data.status === "expired" || (data.status === "trial" && data.trial_days_left <= 5);
  return (
    <Button variant={warn ? "default" : "ghost"} size="sm" asChild data-testid="plan-badge">
      <Link to="/billing" className="text-xs"><CreditCard size={13} className="mr-1.5" />{data.status === "trial" ? `Trial · ${data.trial_days_left}d left` : data.status === "expired" ? "Trial ended · upgrade" : `${data.plan_detail.name} plan`}</Link>
    </Button>
  );
}
